








































































import { Component, Vue } from 'vue-property-decorator';
import { ObjectFactory } from '../../config/objectFactory';
import { ApiRequest, AddLocationRequest } from '../../types/request';
import { validationMixin } from 'vuelidate';
import { required, minLength, email, sameAs} from 'vuelidate/lib/validators';
import { MapUtils } from '../../util/mapUtils';
import { MedTransGoConstants } from '../../util/constants';
import { ToastEvent } from '../../types/event';
import { CommonUtils } from '../../util/commonUtils';
import { EventBus } from '../../main';
import { TransporterLoc } from '../../types/entity';
import { TransporterProfile } from '../../types/response';

declare var google: any;

@Component({
    mixins: [validationMixin],
    props: {
        transportId: String,
    },
    data() {
        return {
            branchName: '',
            phone: '',
            email: '',
            address: {
                fullAddress: '',
                locality: '',
                state: '',
                city: '',
                zip: '',
            },
        };
    },
    validations: {
        branchName: {
            required,
            regex: (fullName) => /^[a-zA-Z ]+$/.test(fullName),
        },
        phone: {
            required,
             minLength: minLength(10),
            regex: (phone) =>  MedTransGoConstants.PHONE_REGX.test(phone),
        },
        email: {
            required,
            email,
        },
        address: {
            fullAddress: {
                required,
            },
            locality: {},
            state: {
                required,
            },
            city: {
                required,
            },
            zip: {
                required,
            },
        },
    },
})
export default class AddLocationModal extends Vue {
    private locationGoogleAddress: any;
    private show = true;
    public mounted() {
        this.getGoogleAddress();
    }

    /**
     * @author <Aniket.P>
     * @description - google places
     * @param req {Request} - Express Request
     * @param res {Response} - Express Response - google places suggession
     * @returns google places suggession
     * @throws InvalidRequestException if network error
     */
    private async getGoogleAddress() {
        this.$root.$on('bv::modal::shown', (bvEvent: any, modalId: any) => {
            this.locationGoogleAddress = new google.maps.places.Autocomplete(
                document.getElementById('locationAddress'), {
                types: ['geocode'],
            },
            );
            this.locationGoogleAddress.addListener('place_changed', () => {
                this.$data.address = MapUtils.parseGoogleAddress(this.locationGoogleAddress);
            });
        });
    }


    /**
     * @author <shraddha.K>
     * @description - add new location
     * @param req {Request} - calls add location API
     * @param res {Response} - Express Response - success result
     * @returns success massage
     * @throws InvalidRequestException if location already exists
     */
    private async addLocation() {
        const iHttpService = ObjectFactory.getHttpService();
        const addLocationRequest: AddLocationRequest = {
            branchName: this.$data.branchName,
            phone: this.$data.phone,
            email: this.$data.email,
            transporterId: this.$props.transportId,
            locationAddress: this.$data.address,
        };
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_TRANSPORTERS}/location/add`,
            data: addLocationRequest,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post<AddLocationRequest>(apiRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: CommonUtils.translateMessageCode('MSG_ADD_LOCATION'),
                title: 'Success!',
                timeout: 2000,
                varient: 'success',
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.$emit('success');
            this.close();
        } else {
            CommonUtils.showError(response);
        }
    }
    private maskPhone(phone: string) {
        return CommonUtils.phoneNumberMask(phone);
    }
    private close() {
            this.$emit('close');
    }
}
